const authRedirectFlag = { active: false };

export default authRedirectFlag;
